
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import LearnHero from './components/LearnHero';
import VideoGrid from './components/VideoGrid';
import FeaturedVideo from './components/FeaturedVideo';
import ProductsUsed from './components/ProductsUsed';
import NewsletterSection from './components/NewsletterSection';

export default function LearnPage() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />
      <LearnHero />
      <VideoGrid />
      <FeaturedVideo />
      <ProductsUsed />
      <NewsletterSection />
      <Footer />
    </div>
  );
}